module.exports = __webpack_public_path__ + "static/img/coupon.b738bf05.svg";